import { AfterViewChecked, ChangeDetectorRef, Component,EventEmitter,ElementRef, Input, OnInit, Output, ViewChild,ViewEncapsulation} from '@angular/core';
import { IUITKRadioGroupItem, IUITKSelectItemProps } from '@uitk/angular';
import { Subscription } from 'rxjs';
import { SwalAlert } from '../../../helpers/alert';
import { InvoiceDetailsDto } from '../../../dtos/invoice-details-dto.model';
import { InvoiceEditDto } from '../../../dtos/invoice-edit-dto.model';
import { AccountsReceivableService } from '../../../services/accounts-receivable.service';
import { ConfigService } from '../../../services/config.service';
import { InvoiceEditService } from '../../../services/invoice-edit.service';
import { ModeService } from '../../../services/mode.service';
import { InvoicesService } from '../../../services/invoices.service';
import { TokenizeService } from '../../../services/tokenize.service';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-invoice-edit',
  templateUrl: './invoice-edit.component.html',
  styleUrls: ['./invoice-edit.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
  
export class InvoiceEditComponent implements OnInit, AfterViewChecked {
  @ViewChild("yesBtn") yesBtn!: ElementRef<HTMLInputElement>;
  @Input() accountId: number = 0;
  @Output() invoiceEdited = new EventEmitter<null>();
  getSelectedInvoicesSubscription: Subscription | undefined;
  selInvoiceList: InvoiceDetailsDto [] = [];
  invoiceError: Subscription | undefined;
  editDialogModal = { show: false };
  selPaymentToken!: IUITKRadioGroupItem;
  selChgPayToken: any;
  ccNumber: string = '';
  token: string = '';
  expDate: string = '';
  fourDigits: string = '';
  defaultLabel = "- Please Select";
  defaultLabelFlag = true;
  invoiceCnt: number = 0;
  date: any;
  isPastDate: boolean = false;
  changeCC = false;
  showCCNumberError = false;
  payMethod: IUITKSelectItemProps | undefined;
  chgPayTokenItems: IUITKRadioGroupItem[] = [
    {
      label: "Yes",
      value: "Yes",
      disabled: false,
    },
    {
      label: "No",
      value: "No",
      disabled: false,
    },
  ];
  payTokenItems: IUITKRadioGroupItem[] = [
    {
      label: "Enter a Credit Card",
      value: "cc",
      disabled: !this.configService.hasResource("EditInvoiceEnterACreditCardRadio"),
    },
    {
      label: "Enter a Token",
      value: "tk",
      disabled: !this.configService.hasResource("EditInvoiceEnterATokenRadio"),
    },
  ];
  isSaveSuccess = false;
  payMethodList: IUITKSelectItemProps[] = [];
  ccPayMethodList: IUITKSelectItemProps[] = [];
  configIsReadySubscription: Subscription | undefined;
  showPayMethodError = false;
  showTokenError = false;
  isRetrievingToken = false;
  showFourDigitsPatternError = false;
  showExpDatePatternError = false;
  showTokenPatternError = false;
  fourDigitsPattern = "^[0-9]+$";
  expDatePattern = /^((0[1-9])|(1[0-2]))(\d{2})$/;
  tokenPattern = "^[a-zA-Z0-9]+$";
  invoiceDetailsToBeUpdated: InvoiceEditDto[] = [];
  skippedInvoices: InvoiceDetailsDto[] = [];
  openAndFutureInvoicesUpdatePopup = {
    show: false
  };
  updateAll = false;
  swalAlert = new SwalAlert();

  constructor(public configService: ConfigService, public invoiceEditService: InvoiceEditService, public accountsReceivableService: AccountsReceivableService,
    public tokenService: TokenizeService, private authorizationService: AuthorizationService, private cdRef: ChangeDetectorRef,public invoicesService: InvoicesService, private modeService: ModeService) {
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }


  ngOnInit(): void {
    this.selChgPayToken = this.chgPayTokenItems[1];
    this.selPaymentToken = this.payTokenItems[0];
    this.payMethodList = this.ccPayMethodList;
    this.ccNumber = '';
    this.invoiceError = this.invoiceEditService.error.subscribe(() => {
      this.swalAlert.alert('Unable to update invoice.  Please try again.');
    });
  }

  onCCChange(encryptedCCStr: any): void {
    if ((encryptedCCStr.length === 157 || encryptedCCStr.length === 158 || encryptedCCStr.length === 177 || encryptedCCStr.length === 178) && encryptedCCStr.endsWith('03')) {
      const firstSet = this.ccNumber.split("?")[0].split("=");
      this.expDate = firstSet[1].substr(2, 2) + firstSet[1].substr(0, 2);
      const secondSet = firstSet[0].split(";");
      this.ccNumber = secondSet[1];
      this.fourDigits = secondSet[1].substr(secondSet[1].length - 4);

      switch (this.ccNumber.substr(0, 1)) {
        case "3":
          this.payMethod = this.payMethodList.find(pmeth => pmeth.label === "American Express");
          break;
        case "4":
          this.payMethod = this.payMethodList.find(pmeth => pmeth.label === "Visa");
          break;
        case "5":
          this.payMethod = this.payMethodList.find(pmeth => pmeth.label === "MasterCard");
          break;
        case "6":
          this.payMethod = this.payMethodList.find(pmeth => pmeth.label === "Discover");
          break;
        default:
          break;
      }
      
      // Start token retrieval with loading state
      this.isRetrievingToken = true;
      this.token = '';
      this.showTokenError = false;
      
      this.tokenService.getCcToken({ encryptedData: encryptedCCStr }).subscribe(
        (data) => {
          this.token = data.token;
          this.isRetrievingToken = false;
        },
        (error) => {
          console.error('Token retrieval failed:', error);
          this.showTokenError = true;
          this.isRetrievingToken = false;
          this.token = '';
        }
      );
    }
    else {
      this.showTokenError = true;
      this.ccNumber = '';
      this.isRetrievingToken = false;
    }

  }


  disableEditButton(invoices: InvoiceDetailsDto[]) {
    this.selInvoiceList = invoices;
    this.accountsReceivableService.updateSelectedInvoicesList(this.selInvoiceList);
    this.invoiceCnt = this.selInvoiceList.length;
    const hasEligibleInvoice = this.selInvoiceList.some(i => i.invoiceNumber !== 'Pending' && i.balance > 0);
    if (hasEligibleInvoice && (this.configService.hasResource('EditCreditMemo') || !this.invoicesService.hasCCMemo)) {
      document.getElementById('editBtn')?.removeAttribute('disabled');
    }
    else {
      document.getElementById('editBtn')?.setAttribute('disabled', 'disabled');
    }
  }




  getDropDownValues() {
    this.ccPayMethodList = this.configService.getPickList("CCPMETH");
  }

  showEditDialog() {
    this.editDialogModal.show = true;
    this.accountsReceivableService.getSelectedInvoicesEmitter.
      subscribe((invoices: InvoiceDetailsDto[]) => {
        this.selChgPayToken = this.chgPayTokenItems[1];
        this.selPaymentToken = this.payTokenItems[0];
        this.invoiceCnt = invoices.length;
        this.selInvoiceList = invoices;
        this.getDropDownValues();
        this.payMethodList = this.ccPayMethodList;
        this.ccNumber = '';
        this.showCCNumberError = false;
      });
  }

  saveInvoice() {
    this.invoiceDetailsToBeUpdated = [];
    this.validateInput();
    const currentUser = this.configService.user.salesId;

    if (this.showPayMethodError === false && this.showTokenError === false
      && this.isPastDate === false && this.showFourDigitsPatternError === false
      && this.showExpDatePatternError === false && this.showTokenPatternError === false) {
      this.editDialogModal.show = false;

      this.skippedInvoices = this.selInvoiceList.filter(i => i.invoiceNumber === 'Pending' || i.balance <= 0);
      const isOpenOrFutureInvoicesExist = this.selInvoiceList.some(i => (i.invoiceNumber === 'Pending' || i.balance > 0));
      this.selInvoiceList = this.selInvoiceList.filter(i => !(i.invoiceNumber == 'Pending' || i.balance <= 0));
      this.selInvoiceList.forEach(element => {
        const invoiceDetailsDto = new InvoiceEditDto();
        invoiceDetailsDto.invoiceNumber = element.invoiceNumber;
        invoiceDetailsDto.userLogin = this.authorizationService.getMyMSId();
        invoiceDetailsDto.orderNumber = element.orderNumber;
        invoiceDetailsDto.invoiceDate = element.invoiceDate;
        invoiceDetailsDto.balance = element.balance;
        invoiceDetailsDto.isSelected = true;


        switch (true) {
          case ((this.selPaymentToken.value === "cc" || this.selPaymentToken.value === "tk") && (this.selChgPayToken.value === "Yes")):
            invoiceDetailsDto.changeCreditCard = true;
            invoiceDetailsDto.changePaymentTerms = false;
            invoiceDetailsDto.expirationDate = this.expDate.trim() === "" ? "0199" : this.expDate;
            invoiceDetailsDto.ccLastFour = this.fourDigits.trim() === "" ? "0000" : this.fourDigits;
            invoiceDetailsDto.token = this.token;
            invoiceDetailsDto.paymentMethod = this.payMethod?.label.replace(' ', '') ?? '';
            break;
          default:
            invoiceDetailsDto.changeCreditCard = false;
            invoiceDetailsDto.changePaymentTerms = false;
            break;
        }

        invoiceDetailsDto.userLogin = currentUser;
        this.invoiceDetailsToBeUpdated.push(invoiceDetailsDto);
      });

      if ((this.selPaymentToken.value === "cc" || this.selPaymentToken.value === "tk") && (this.selChgPayToken.value === "Yes")) {
        if (isOpenOrFutureInvoicesExist) {
          this.openAndFutureInvoicesUpdatePopup.show = true;

          setTimeout(() => {
            this.yesBtn.nativeElement.focus();
          }, 500);
        }
        else {
          this.updatePaymentDetailsForSelectedInvoices();  
        }
      }
      else {
        this.updatePaymentDetailsForSelectedInvoices();
      }
    }
  }


  updatePaymentDetailsForOpenAndFutureInvoices(): void {
    this.openAndFutureInvoicesUpdatePopup.show = false;
    const updatingInvoicesMsg = "Updating Invoices";
    this.modeService.addToWaitList(updatingInvoicesMsg);
    
    this.invoiceEditService
    .updateInvoiceDetails(this.accountId.toString(), this.invoiceDetailsToBeUpdated, true)
    .subscribe({
      next: () => {
        this.modeService.removeFromWaitList(updatingInvoicesMsg);
        this.invoiceEdited.emit();
        this.swalAlert.alert(this.getPostSaveMessage());
        this.isSaveSuccess = true;

        this.selInvoiceList = [];
        this.invoiceDetailsToBeUpdated = [];
      },
      error: (error: any) => {
        this.modeService.removeFromWaitList(updatingInvoicesMsg);
        console.error(error);
        this.swalAlert.alert('An error occurred while updating the invoice details');
      }
    });
  }

  updatePaymentDetailsForSelectedInvoices(): void{
    this.openAndFutureInvoicesUpdatePopup.show = false;
    this.invoiceDetailsToBeUpdated = this.invoiceDetailsToBeUpdated.filter(i => i.isSelected);

    const updatingInvoicesMsg = "Updating Invoices";
    this.modeService.addToWaitList(updatingInvoicesMsg);
    
    this.invoiceEditService
    .updateInvoiceDetails(this.accountId.toString(), this.invoiceDetailsToBeUpdated, false)
    .subscribe({
      next: () => {
        this.modeService.removeFromWaitList(updatingInvoicesMsg);
        this.invoiceEdited.emit();
        this.swalAlert.alert(this.getPostSaveMessage());
        this.isSaveSuccess = true;

        this.selInvoiceList = [];
        this.invoiceDetailsToBeUpdated = [];
      },
      error: (error: any) => {
        this.modeService.removeFromWaitList(updatingInvoicesMsg);
        console.error(error);
        this.swalAlert.alert('An error occurred while updating the invoice details');
      }
    });

  }

  getPostSaveMessage(): string {
    const eligibleSkipped = this.skippedInvoices.filter(i => i.invoiceNumber !== 'Pending');
    this.skippedInvoices = [];
    if (eligibleSkipped.length > 0) {
      const invoiceNumbers = eligibleSkipped.map(inv => inv.invoiceNumber).join(', ');
      return `Invoice(s) ${invoiceNumbers} was/were not updated with the new token because the invoice balance is $0.00.`;
    }
    return 'Invoice Details updated successfully';
  }

  validateInput() {
    this.showPayMethodError = false;
    this.showTokenError = false;
    this.isPastDate = false;
    this.showFourDigitsPatternError = false;
    this.showExpDatePatternError = false;
    this.showTokenPatternError = false;

    if ((this.selChgPayToken.value === "Yes") && (this.selPaymentToken?.value === "cc" || this.selPaymentToken?.value === "tk")) {

      if (this.payMethod === undefined)
      {
        this.showPayMethodError = true;
      } 
      this.tokenChange(this.token);
      this.expDateChange(this.expDate);
      this.fourDigitsChange(this.fourDigits)
    }
    if(this.selPaymentToken?.value === "cc" ){
      if(!this.ccNumber){
        this.showCCNumberError = true;
      }
    }
    else{
      this.showCCNumberError = true;
    }
  }
  closeDialog() {
    this.editDialogModal.show = false;
  }
  tokenChange(token: string) {
    if (token !== ""){
      this.showTokenError = false;
    }      
    else{
      this.showTokenError = true;
    }     

    if (token !== "" && token !== null && !new RegExp(this.tokenPattern).test(token)){
      this.showTokenPatternError = true;
    }      
    else{
      this.showTokenPatternError = false;
    }
  }
  payMethodChange(payMethod: IUITKSelectItemProps | undefined) {
    if (payMethod != null){
      this.showPayMethodError = false;
    }
  }
  expDateChange(expDate: string) {
    if (expDate !== "" && expDate !== null && !new RegExp(this.expDatePattern).test(expDate)){
      this.showExpDatePatternError = true;
    }      
    else{
      this.showExpDatePatternError = false;
    }     


    if (expDate !== "" && expDate !== null && expDate.length === 4) {

      this.isPastDate = false;
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2));
      const expYear = parseInt(this.expDate.substr(2, 2));
      const expMonth = parseInt(this.expDate.substr(0, 2));
      if (expYear < currentYear) {
        this.isPastDate = true;
      }
      else if (expYear === currentYear && expMonth < currentMonth) {
        this.isPastDate = true;
      }
      else {
        this.isPastDate = false;
      }
    }
    else
    {
      this.isPastDate = false;
    }
  }

  fourDigitsChange(fourDigits: string) {
    if (fourDigits !== "" && fourDigits !== null && !new RegExp(this.fourDigitsPattern).test(fourDigits)){
      this.showFourDigitsPatternError = true;
    }    
    else{
      this.showFourDigitsPatternError = false;
    }
  }

  PopultateDefaultPaymentToken() {
    if (this.selChgPayToken.value === 'Yes') {
      this.selPaymentToken = this.payTokenItems[0];
      this.selPaymentToken.value = 'cc';
      if (this.ccPayMethodList.length <= 0){
        this.getDropDownValues();
      }

      this.payMethodList = this.ccPayMethodList;
      this.showPayMethodError = false;
      this.showTokenError = false;
      this.isPastDate = false;
      this.showFourDigitsPatternError = false;
      this.showExpDatePatternError = false;
      this.showTokenPatternError = false;
      this.isRetrievingToken = false;
      this.token = '';
      this.expDate = '';
      this.ccNumber = '';
      this.fourDigits = '';
      this.payMethod = undefined;
    }
  }

  PaymentTokenChange() {
    if (this.ccPayMethodList.length <= 0){
      this.getDropDownValues();
    }      

    if ((this.selPaymentToken.value === 'cc') || (this.selPaymentToken.value === 'tk')) {
      this.payMethodList = this.ccPayMethodList;
      this.changeCC = true;
    }

    this.showPayMethodError = false;
    this.showTokenError = false;
    this.isPastDate = false;
    this.showFourDigitsPatternError = false;
    this.showExpDatePatternError = false;
    this.showTokenPatternError = false;
    this.showCCNumberError = false;
    this.isRetrievingToken = false;
  }

  ngOnDestroy() {
    this.configIsReadySubscription?.unsubscribe();
    this.invoiceError?.unsubscribe();
    this.getSelectedInvoicesSubscription?.unsubscribe();
  }
}
